import { CRITICALITIES } from "./criticality";

/**
 * The list's criticality filters: All, then one per level. A row is under its own level only, the
 * one its pill shows (feature_watchdog/issues-page/refinement.md → Criticality filters).
 */
export const ALL = "all";

export const CRITICALITY_FILTERS = [{ key: ALL, label: "All" }, ...Object.values(CRITICALITIES)];

/** The filter `key` names, All for none or an unknown one. */
export const criticalityFilterOf = (key) => (CRITICALITIES[key] ? key : ALL);

/** How many of the rows each filter holds, by key. */
export const countsOf = (rows) => Object.fromEntries(CRITICALITY_FILTERS.map(({ key }) => [key, rowsUnder(key, rows).length]));

/** The rows of the level `key` names, or all of them. */
export const rowsUnder = (key, rows) => (key === ALL ? rows : rows.filter(({ criticality }) => criticality.key === key));
